
<div class="fileUpload">
  <input #inputFile type="file" hidden [accept]="accept" (change)="onFileSelected($event)" (click)="inputFile.value='';" />

  <div class="fileUpload-drag-and-drop-button" (click)="inputFile.click()">
    <p class="d-flex flex-column align-items-center highlight-text" innerHTML="{{ 'Domiciliation.DomiciliationDragDropInfo' | translate }}">
    </p>
  </div>

  <div class="d-flex flex-row justify-content-center align-items-center Upload-file-name">
    @if (fileuploadSuccessful) {
      <span class="me-2">
        <img class="success-img" src="assets/images/domiciliation/sucess-tick.png"/>
      </span>
    }
    <span>{{ file ? file.fileNameWithExtension : ('Domiciliation.DomiciliationNoFileSelected' | translate) }}</span>
    <span class="me-2 mt-2">
      @if (file) {
        <mat-icon (click)="onClear()">close</mat-icon>
      }
    </span>
  </div>

  @if (hasContentTypeError) {
    <div class="fileUpload-invalid">
      <span>{{ 'web.file-upload.content-type-error' | translate }}</span>
    </div>
  }

  @if (hasMaxContentSizeError) {
    <div class="fileUpload-invalid">
      <span>{{ 'web.file-upload.content-size-error' | translate }}</span>
    </div>
  }

  @if (isImageType) {
    <div class="fileUpload-image-preview">
      <img [alt]="file?.fileNameWithExtension" [src]="imageSrc" />
    </div>
  }
</div>
